import classNames from 'classnames'
import { Parallax } from 'react-parallax'

import type { Props as CTAProps } from '../CallToAction'
import type { Image } from 'types'
import { parseImageSrc } from 'ui-component-library/utils/helpers'
import L1Badge from 'ui-component-library/icons/badge-l1.svg'
import L2Badge from 'ui-component-library/icons/badge-l2.svg'
import CallToAction from '../CallToAction'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'

import style from './style.scss'

type Props = {
  badge?: 'level1' | 'level2'
  className?: string
  cta: CTAProps
  image: Image
  kickerHeadlineText?: string
  buttonColor: 'red' | 'blue'
  imageDarken?: boolean
}

function FullWidthPromo(props: Props) {
  const {
    buttonColor,
    badge,
    className,
    cta,
    kickerHeadlineText,
    image,
    imageDarken,
  } = props
  const { alt: bgImageAlt, src: imageSrc } = image
  const { srcSet: bgImageSrcSet, src: bgImage } = parseImageSrc(imageSrc)

  return (
    <div className={classNames(style.wrapper, className)}>
      <Parallax
        bgImage={bgImage}
        bgImageAlt={bgImageAlt}
        bgImageSrcSet={bgImageSrcSet}
        strength={75}
      >
        <div
          className={classNames(style.innerContent, {
            [style.darken]: imageDarken,
          })}
        >
          {badge && badge === 'level1' && (
            <L1Badge className={style.badge} data-testid='badge-icon' />
          )}

          {badge && badge === 'level2' && (
            <L2Badge className={style.badge} data-testid='badge-icon' />
          )}

          {kickerHeadlineText && (
            <HeadlineTwo>{kickerHeadlineText}</HeadlineTwo>
          )}
          <CallToAction
            className={style.cta}
            rulerClass={classNames(style.ctaRuler, {
              [style.rulerHidden]: !!badge,
            })}
            {...cta}
            buttonColor={buttonColor}
          />
        </div>
      </Parallax>
    </div>
  )
}

export default FullWidthPromo
